import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class HolidaysCalendarDTO {
  @ApiProperty()
  @IsNotEmpty({message:"holidayId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  holidayId?: number;

  @ApiProperty()
  @IsNotEmpty({message:"holidayName should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  holidayName: string;

    @ApiProperty()
    @IsDate()
    holidayDate: Date;

    // @ApiProperty()
    // @IsDate()
    // holidayYear: Date;

 

  @ApiProperty()
  @IsOptional()
  isActive: boolean;

  @ApiProperty()
  @IsOptional()
  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

